<template id="menu-cont">
    <nav id="sidebar">

        <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center; height: 40vh;">

            <div style="width: 100%; text-align: center;">
                <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="width: 70%; max-height: 10vh; margin-top: 5vh; margin-bottom: 2.5vh; object-fit: contain">
            </div>

            <div v-if="user.sucess" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                <span style="font-size: 2.5vh;">{{ getInterText(inter_ind.ola) }} {{ getFirstAndLastWords(user.nome) }}</span>

                <div class="div_botao_t" @click="logout()" onMouseOver="this.style.cursor='pointer'">
                    <span class="tx_continuar"> {{ getInterText(inter_ind.sair) }} </span>
                </div>
            </div>
            <div v-else style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                <router-link to="registerUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                    <div class="div_botao_t_w">
                        <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                    </div>
                </router-link>

                <div class="div_botao_t" @click="setShowLogin(true)">
                    <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                </div>
            </div>


            <div class="custom-select-filtro">
                <select class=".selectCity" id="sel_cats" @change="changeCity($event)" v-model="cityIndex" >
                    <option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>
                    <option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>
                </select>
                <img src="/static/imgs/ic_down.png" style="width: 5%; margin-right: 3%; object-fit: contain;">
            </div>


        </div>
        <div style="display: flex; flex-direction: column; height: 57vh;">
            <ul class="list-unstyled components noScrollMenu" style="margin-top: 0; display: flex; flex-direction: column; overflow-y: scroll; font-size: 1.2vw; height: max-content; flex-grow: 90; flex-shrink: 0;">
                <li class="active">
                    <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.categorias) }}</a>
                    <ul class="collapse list-unstyled" id="pageSubmenu" >
                        <li v-for="item in cats_full" @click="atualizaEstabs(item.id, true)">
                            <div class="lineMenu">
                                <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">
                                <span>{{ getInterCatName(item) }}</span>
                            </div>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="/Visao" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.quem_somos) }}</a>
                </li>

                <li class="active">
                    <a style="font-family: 'Humanst521BT';" href="#pageSubmenu3" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu3">{{ getInterText(inter_ind.nossas_redes) }}</a>
                    <ul class="collapse list-unstyled" id="pageSubmenu3" >
                        <li>
                            <a href="https://www.facebook.com/adviceparaiba" target="_blank">
                                <img src="/static/imgs/ic_facebookmenu.png" class="im_cat_min_2">
                                <span>Facebook</span>
                            </a>
                            <a href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg" target="_blank">
                                <img src="/static/imgs/ic_youtubemenu.png" class="im_cat_min_2">
                                <span>YouTube</span>
                            </a>
                            <a href="https://www.instagram.com/adviceparaiba/" target="_blank">
                                <img src="/static/imgs/ic_instagrammenu.png" class="im_cat_min_2">
                                <span>Instagram</span>
                            </a>
                            <a href="https://twitter.com/AdviceParaiba" target="_blank">
                                <img src="/static/imgs/ic_twittermenu.png" class="im_cat_min_2">
                                <span>Twitter</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!--<li @click="changeShow10Mais()">-->
                <li>
                    <a style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.os) }} 10+</a>
                </li>
                <li>
                    <a href="/Contato" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.contato) }}</a>
                </li>
                <li>
                    <a href="/ExpedicaoAdvice" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.expedicao) }}</a>
                </li>
                <li class="active">
                    <a style="font-family: 'Humanst521BT';" href="#pageSubmenu2" data-toggle="collapse"x aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                    <ul class="collapse list-unstyled" id="pageSubmenu2">
                        <li v-for="item in telefoneUteis">
                            <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                        </li>
                    </ul>
                </li>
            </ul>

            <!-- PARCEIROS -->
            <div class="div_pat_m">
                <hr class="hr_pat"/>
                <!--<span class="tx_parceiros">PARCEIROS</span><br>-->
                <div style="display: flex;">
                    <a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPathW" class="im_pat_m"/></a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import { advMixin } from '../../scripts/advMixin';
    // import Vue from 'vue';

    // Vue.mixin(advMixin);

    export default {
        mixins: [advMixin],
        name: 'MenuBar',
        data () {
            return {

            }
        },
        methods: {

        },
        created() {
            console.log('created!!');

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            console.log('Terminei o mounted!!');
        },

    }



</script>


<style src="../../assets/css/menu_icon.css" scoped/>
<style src="../../assets/css/advDesk.css" scoped/>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }
    .im_menu1 {
        height: 25px;
        vertical-align: middle;
        margin-left: 5px;
        top: 0;
        bottom: 0;
        margin-top: auto;
        margin-bottom: auto;
    }
    .im_menu1 {
        top: 0;
        left: 0;
        position: relative;
        margin-left: 0px;
    }
    .im_cat_min {
        width: 17px;
        height: 17px;
        margin-right: 10px;
        object-fit: contain;
    }

</style>



// WEBPACK FOOTER //
// src/components/templates/SideMenu.vue